import React from 'react';
import { Button } from './ui/Button';
import { Badge } from './ui/Badge';
import { Shield, Award, ShieldCheck, BadgeCheck } from 'lucide-react';
export function HeroSection() {
  const trustIndicators = [{
    text: 'Veteran-Owned',
    icon: Award
  }, {
    text: 'FAA Part 107 Certified',
    icon: BadgeCheck
  }, {
    text: '$1M Insured',
    icon: Shield
  }, {
    text: 'BBB Accredited',
    icon: ShieldCheck
  }];
  return <section className="relative min-h-screen flex items-center justify-center pt-[60px] lg:pt-[80px] font-heading overflow-hidden" data-id="element-86">
      {/* Parallax Background */}
      <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/ieqoT7xMnStBRaVqbD788j/1-8_watermarked2B(1)-1920w.webp")'
    }} data-id="element-87" />

      {/* Gradient Overlay */}
      <div className="absolute inset-0 w-full h-full" style={{
      background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%)'
    }} data-id="element-88" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full flex flex-col items-center text-center py-20" data-id="element-89">
        <h1 className="text-white font-bold text-4xl sm:text-5xl lg:text-6xl xl:text-7xl leading-tight mb-6 max-w-4xl uppercase tracking-tight" style={{
        textShadow: '0 3px 12px rgba(0,0,0,0.7), 0 1px 3px rgba(0,0,0,0.5)'
      }} data-id="element-90">
          Commercial & Residential Cleaning, Powered by Drones.
        </h1>

        <p className="text-white/90 text-lg sm:text-xl lg:text-2xl mb-10 max-w-3xl font-semibold" style={{
        textShadow: '0 3px 12px rgba(0,0,0,0.7), 0 1px 3px rgba(0,0,0,0.5)'
      }} data-id="element-91">
          If a bee can reach it, then so can we! — Veteran-owned, FAA-certified
          drone cleaning serving Arizona & Southern California.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto mb-16" data-id="element-92">
          <Button className="w-full sm:w-auto bg-[#F5A623] hover:bg-[#E09520] text-[#1B3A5C] font-bold text-lg h-14 px-8 rounded-lg" data-id="element-93">
            Get a Free Estimate
          </Button>
          <Button variant="outline" className="w-full sm:w-auto bg-transparent hover:bg-white/10 text-white border-2 border-white font-bold text-lg h-14 px-8 rounded-lg" data-id="element-94">
            Our Services
          </Button>
        </div>

        {/* Trust Indicators */}
        <div className="flex flex-wrap justify-center gap-3 sm:gap-4 w-full" data-id="element-95">
          {trustIndicators.map((item, index) => {
          const Icon = item.icon;
          return <Badge key={index} variant="outline" className="bg-black/30 backdrop-blur-sm border-white/30 text-white py-2 px-3 sm:px-4 text-xs sm:text-sm font-medium flex items-center gap-2 rounded-full" data-id="element-96">
                <Icon className="w-4 h-4 text-[#F5A623]" data-id="element-97" />
                {item.text}
              </Badge>;
        })}
        </div>
      </div>
    </section>;
}